import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Radio,
  FormControlLabel,
  RadioGroup,
  TextField,
  Paper,
  Table,
  Grid,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Alert,
  Snackbar,
} from "@mui/material";
import ReusableTable from "./TableComponent";
import ReusableWageTable from "./ReusableWageTable";
import CustomTableRow from "./CustomeTableRow";
import CustomTable from "./CustomeTable1";
import style from "../../../../styles/brsr/general.module.css";
import TableField from "./TableField";
import EastIcon from "@mui/icons-material/East";
import { put, api, get } from "../../../../utils/api";
import ComplaintsTable from "./ComplaintsTable";
import { useParams } from "react-router-dom";
import { brsrReview, reviewBRSR } from "../../../../utils/companyId";
import ReviewBox from "../../../Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";
import BRSRFile from "../../../Common/BRSRFile";

const EssentialIndicator = ({
  onSave,
  hide,
  removeUpload = false,
  downloadMode = false,
}) => {
  const { id } = useParams();
  const [errors, setErrors] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [modalupload, setModalUpload] = useState({
    humanRightsTrainingDoc: false,
    minimumWagesDoc: false,
    remunerationDetailsDoc: false,
    humanRightsFocalPointDoc: false,
    complaintsFiledDoc: false,
    complaintsFiledUnderSexualHarassemntDoc: false,
    mechanismsToPreventAdverseConsequencesDoc: false,
    humanRightsRequirementsInAgreementsDoc: false,
    assessmentsForYearDoc: false,
    correctiveActionsForAssessmentsDoc: false,
  });
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [progress, setUploadProgress] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData1, setFormData1] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [data, setData] = useState({
    employees: [
      {
        category: "Permanent Employees",
        currentYear: [null, null, null],
        previousYear: [null, null, null],
      },
      {
        category: "Other than Permanent",
        currentYear: [null, null, null],
        previousYear: [null, null, null],
      },
      {
        category: "Total ",
        currentYear: [null, null, null],
        previousYear: [null, null, null],
      },
    ],
    workers: [
      {
        category: "Permanent  Workers",
        currentYear: [null, null, null],
        previousYear: [null, null, null],
      },
      {
        category: "Other than Permanent",
        currentYear: [null, null, null],
        previousYear: [null, null, null],
      },
      {
        category: "Total ",
        currentYear: [null, null, null],
        previousYear: [null, null, null],
      },
    ],
  });

  const [employeeErrors, setEmployeeErrors] = useState({});
  const [workerErrors, setWorkerErrors] = useState({});
  const [minimumWagesErrors, setMinimumWagesErrors] = useState({});

  const [medianRemuneration, setMedianRemuneration] = useState({
    boardOfDirectors: {
      numberofmale: "",
      maleWages: "",
      numberofFemale: "",
      femaleWages: "",
    },
    keyManagementPersonnel: {
      numberofmale: "",
      maleWages: "",
      numberofFemale: "",
      femaleWages: "",
    },
    otherEmployees: {
      numberofmale: "",
      maleWages: "",
      numberofFemale: "",
      femaleWages: "",
    },
    workers: {
      numberofmale: "",
      maleWages: "",
      numberofFemale: "",
      femaleWages: "",
    },
  });

  const [minimumWages, setMinimumWages] = useState({
    currentFinancialYear: {
      permanentEmployees: {
        male: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
        female: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
        totalAddition: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
      },
      otherThanPermanentEmployees: {
        male: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
        female: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
        totalAddition: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
      },
      permanentWorkers: {
        male: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
        female: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
        totalAddition: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
      },
      otherThanPermanentWorkers: {
        male: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
        female: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
        totalAddition: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
      },
    },
    previousFinancialYear: {
      permanentEmployees: {
        male: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
        female: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
        totalAddition: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
      },
      otherThanPermanentEmployees: {
        male: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
        female: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
        totalAddition: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
      },
      permanentWorkers: {
        male: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
        female: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
        totalAddition: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
      },
      otherThanPermanentWorkers: {
        male: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
        female: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
        totalAddition: {
          total: 0,
          equalWageMin: { number: 0, percentage: "" },
          equalWageMax: { number: 0, percentage: "" },
        },
      },
    },
  });

  const [formData, setFormData] = useState({
    // for 3rd b question

    currentFinancialYear: "",
    previousFinancialYear: "",

    sexualHarassment: "",
    discrimination: "",
    childLabor: "",
    forcedLabor: "",
    wages: "",
    // other: "",
    other: { others: "", percentageValue: "" },
    // 4th feild
    humanRightsFocalPoint: {
      status: "true",
      remark: "",
    },
    //7th question
    totalComplaints: { currentFinancialYear: "", previousFinancialYear: "" },
    complaintsFemaleEmployee: {
      currentFinancialYear: "",
      previousFinancialYear: "",
    },
    poshUpheld: { currentFinancialYear: "", previousFinancialYear: "" },

    // 8th question
    mechanismsToPreventAdverseConsequences: "",

    //9th question
    humanRightsRequirementsInAgreements: {
      action: "true",
      bref: "",
    },

    //11 question
    correctiveActionsForAssessments: "",
  });
  const [dynamicLabel, setDynamicLabel] = useState("");

  const complaintsType = {
    sexualHarassemnt1: { fliedYear: 0, pending: 0, remark: "" },
    discrimination2: { fliedYear: 0, pending: 0, remark: "" },
    childLabor3: { fliedYear: 0, pending: 0, remark: "" },
    forcedLabor4: { fliedYear: 0, pending: 0, remark: "" },
    wages5: { fliedYear: 0, pending: 0, remark: "" },
    other6: { fliedYear: 0, pending: 0, remark: "" },
  };

  const initialComplaintsFiled = {
    currentFinancialYear1: { ...complaintsType },
    previousFinancialYear1: { ...complaintsType },
  };

  const [complaintsFiled, setComplaintsFiled] = useState(
    initialComplaintsFiled,
  );
  const [validationErrors, setValidationErrors] = useState({});

  const categories = [
    { label: "a. Permanent employees", key: "permanentEmployees" },
    {
      label: "b. Other than permanent employees",
      key: "otherThanPermanentEmployees",
    },
    { label: "c. Permanent workers", key: "permanentWorkers" },
    {
      label: "d. Other than permanent workers",
      key: "otherThanPermanentWorkers",
    },
  ];

  const handleRadioChange = (event) => {
    const { name, value } = event.target;

    setFormData((prev) => {
      const newData = {
        ...prev,
        [name]: {
          ...prev[name],
          [name === "humanRightsFocalPoint" ? "status" : "action"]: value,
          [name === "humanRightsFocalPoint" ? "remark" : "bref"]:
            value === "false"
              ? ""
              : prev[name][
                  name === "humanRightsFocalPoint" ? "remark" : "bref"
                ],
        },
      };
      return newData;
    });
  };

  const type = "SectionC";
  // Fetch saved data on component mount

  useEffect(() => {
    const fetchSavedData = async () => {
      try {
        const response = await get(
          `${api}/brsr/get?subType=principle5&type=${type}&id=${id}`,
        );
        if (
          response?.data?.data?.year
            ? response?.data?.data?.year < currentYear - 1
            : false || !brsrReview
        )
          setDisabled(true);

        if (
          response &&
          response.data &&
          response.data.data.BRSRSectionC &&
          response.data.data.BRSRSectionC.principle5.essentialIndicators
        ) {
          const essentialIndicators =
            response.data.data.BRSRSectionC.principle5.essentialIndicators;

          const humanRightsTraining = essentialIndicators.humanRightsTraining;
          if (essentialIndicators.minimumWages) {
            // ✅ Inline deep merge without extra function
            setMinimumWages((prev) => {
              const mergeRecursively = (target, source) => {
                if (
                  typeof target !== "object" ||
                  target === null ||
                  Array.isArray(target)
                )
                  return source !== undefined ? source : target;
                // return source ?? target;

                const merged = { ...target };
                for (const key in source) {
                  if (source.hasOwnProperty(key)) {
                    merged[key] = mergeRecursively(target[key], source[key]);
                  }
                }
                return merged;
              };

              return mergeRecursively(prev, essentialIndicators.minimumWages);
            });
          }
          if (humanRightsTraining) {
            const mapTrainingData = (trainingData, category) => {
              return [
                {
                  category: `Permanent ${category}`,
                  currentYear: [
                    trainingData?.currentFinancialYear?.permanentEmployees
                      ?.total ?? null,
                    trainingData?.currentFinancialYear?.permanentEmployees
                      ?.noOfEmployee ?? null,
                    trainingData?.currentFinancialYear?.permanentEmployees
                      ?.percentage ?? null,
                  ],
                  previousYear: [
                    trainingData?.previousFinancialYear?.permanentEmployees
                      ?.total ?? null,
                    trainingData?.previousFinancialYear?.permanentEmployees
                      ?.noOfEmployee ?? null,
                    trainingData?.previousFinancialYear?.permanentEmployees
                      ?.percentage ?? null,
                  ],
                },
                {
                  category: "Other than Permanent",
                  currentYear: [
                    trainingData?.currentFinancialYear?.otherThanPermanent
                      ?.total ?? null,
                    trainingData?.currentFinancialYear?.otherThanPermanent
                      ?.noOfEmployee ?? null,
                    trainingData?.currentFinancialYear?.otherThanPermanent
                      ?.percentage ?? null,
                  ],
                  previousYear: [
                    trainingData?.previousFinancialYear?.otherThanPermanent
                      ?.total ?? null,
                    trainingData?.previousFinancialYear?.otherThanPermanent
                      ?.noOfEmployee ?? null,
                    trainingData?.previousFinancialYear?.otherThanPermanent
                      ?.percentage ?? null,
                  ],
                },
                {
                  category: "Total",
                  currentYear: [
                    trainingData?.currentFinancialYear?.total?.total ?? null,
                    trainingData?.currentFinancialYear?.total?.noOfEmployee ??
                      null,
                    trainingData?.currentFinancialYear?.total?.percentage ??
                      null,
                  ],
                  previousYear: [
                    trainingData?.previousFinancialYear?.total?.total ?? null,
                    trainingData?.previousFinancialYear?.total?.noOfEmployee ??
                      null,
                    trainingData?.previousFinancialYear?.total?.percentage ??
                      null,
                  ],
                },
              ];
            };
            setFormData1(essentialIndicators);
            setData({
              employees: mapTrainingData(
                humanRightsTraining.employee,
                "Employees",
              ),
              workers: mapTrainingData(humanRightsTraining.workers, "Workers"),
            });
          }

          // Other state updates...
          setFormData({
            currentFinancialYear:
              essentialIndicators.remunerationDetails.femalePercentage
                .currentFinancialYear,
            previousFinancialYear:
              essentialIndicators.remunerationDetails.femalePercentage
                .previousFinancialYear,
            sexualHarassment:
              essentialIndicators.assessmentsForYear.sexualHarassment
                .plantsOffices,
            discrimination:
              essentialIndicators.assessmentsForYear.discrimination
                .plantsOffices,
            childLabor:
              essentialIndicators.assessmentsForYear.childLabor.plantsOffices,
            forcedLabor:
              essentialIndicators.assessmentsForYear.forcedLabor.plantsOffices,
            wages: essentialIndicators.assessmentsForYear.wages.plantsOffices,
            other: essentialIndicators.assessmentsForYear.other,
            humanRightsFocalPoint: essentialIndicators.humanRightsFocalPoint,
            totalComplaints:
              essentialIndicators.complaintsFiledUnderSexualHarassemnt
                .totalComplaints,
            complaintsFemaleEmployee:
              essentialIndicators.complaintsFiledUnderSexualHarassemnt
                .complaintsFemaleEmployee,
            poshUpheld:
              essentialIndicators.complaintsFiledUnderSexualHarassemnt
                .poshUpheld,
            mechanismsToPreventAdverseConsequences:
              essentialIndicators.mechanismsToPreventAdverseConsequences,
            humanRightsRequirementsInAgreements:
              essentialIndicators.humanRightsRequirementsInAgreements,
            correctiveActionsForAssessments:
              essentialIndicators.correctiveActionsForAssessments,
          });
          setComplaintsFiled(essentialIndicators.complaintsFiled);
          setMedianRemuneration(
            essentialIndicators.remunerationDetails.medianRemuneration,
          );
        } else {
          console.error("Essential Indicator data is not available.");
        }
      } catch (error) {
        console.error("Failed to fetch saved data:", error);
      }
    };

    fetchSavedData();
  }, [api, id, type]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      // Handle nested fields conditionally
      if (
        name in prev.humanRightsFocalPoint &&
        prev.humanRightsFocalPoint.status === "true"
      ) {
        return {
          ...prev,
          humanRightsFocalPoint: {
            ...prev.humanRightsFocalPoint,
            [name]: value,
          },
        };
      }
      // if (
      //   name in prev.humanRightsRequirementsInAgreements &&
      //   prev.humanRightsRequirementsInAgreements.action === "true"
      // )
      if (name in prev.humanRightsRequirementsInAgreements) {
        return {
          ...prev,
          humanRightsRequirementsInAgreements: {
            ...prev.humanRightsRequirementsInAgreements,
            [name]: value,
          },
        };
      }

      // For all other fields, update them directly
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleInputChange5 = (category, field, value) => {
    // Update the medianRemuneration state
    setMedianRemuneration((prevState) => ({
      ...prevState,
      [category]: {
        ...prevState[category],
        [field]: value,
      },
    }));

    // Dynamically validate the field and remove its error if valid
    setValidationErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      const fieldKey = `${category}_${field}`;

      // Check if the value is valid
      if (
        value !== "" &&
        value !== null &&
        !isNaN(value) &&
        parseFloat(value) >= 0
      ) {
        delete updatedErrors[fieldKey]; // Remove the error for the valid field
      } else if (value === "" || value === null) {
        updatedErrors[fieldKey] = "This field is required.";
      } else if (isNaN(value) || parseFloat(value) < 0) {
        updatedErrors[fieldKey] = "Please enter a valid numeric value.";
      }

      return updatedErrors;
    });
  };

  const validateMedianRemuneration = () => {
    let isValid = true;
    const errors = {};

    Object.keys(medianRemuneration).forEach((category) => {
      Object.keys(medianRemuneration[category]).forEach((field) => {
        const value = medianRemuneration[category][field];
        if (value === "" || value === null) {
          isValid = false;
          errors[`${category}_${field}`] = "This field is required.";
        } else if (isNaN(value) || parseFloat(value) < 0) {
          isValid = false;
          errors[`${category}_${field}`] =
            "Please enter a valid numeric value.";
        }
      });
    });

    setValidationErrors(errors);
    return isValid;
  };

  const validateMinimumWages = () => {
    let isValid = true;
    const errors = {};

    ["currentFinancialYear", "previousFinancialYear"].forEach((year) => {
      [
        "permanentEmployees",
        "otherThanPermanentEmployees",
        "permanentWorkers",
        "otherThanPermanentWorkers",
      ].forEach((category) => {
        ["male", "female"].forEach((gender) => {
          const categoryData = minimumWages[year][category][gender];

          // Validate total field - require non-zero value
          if (
            categoryData.total === "" ||
            categoryData.total === null ||
            categoryData.total === undefined ||
            categoryData.total === 0
          ) {
            isValid = false;
            errors[`${year}_${category}_${gender}_total`] =
              "Total is required.";
          } else if (
            isNaN(categoryData.total) ||
            parseFloat(categoryData.total) < 0
          ) {
            isValid = false;
            errors[`${year}_${category}_${gender}_total`] =
              "Please enter a valid number.";
          }

          // Validate wage fields - require non-zero value
          ["equalWageMin", "equalWageMax"].forEach((wageType) => {
            if (categoryData[wageType]) {
              const number = categoryData[wageType].number;
              if (
                number === "" ||
                number === null ||
                number === undefined ||
                number === 0
              ) {
                isValid = false;
                errors[`${year}_${category}_${gender}_${wageType}`] = `${
                  wageType === "equalWageMin"
                    ? "Equal to Minimum Wage"
                    : "More than Minimum Wage"
                } is required.`;
              } else if (isNaN(number) || parseFloat(number) < 0) {
                isValid = false;
                errors[`${year}_${category}_${gender}_${wageType}`] =
                  "Please enter a valid number.";
              }
            }
          });
        });
      });
    });

    setMinimumWagesErrors(errors);
    return isValid;
  };

  const handleInputChange4 = (e, yearType, label, field) => {
    const { name, value } = e.target;

    // Update the formData state
    setFormData((prevData) => ({
      ...prevData,
      [yearType]: {
        ...prevData[yearType],
        [field]: value,
      },
    }));

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      const errorKey = `${yearType}.${field}`;

      // Handle both string and number values properly
      const trimmedValue = value != null ? String(value).trim() : "";

      if (!trimmedValue) {
        updatedErrors[errorKey] = "This field is required.";
      } else if (isNaN(trimmedValue) || parseFloat(trimmedValue) < 0) {
        updatedErrors[errorKey] = "Please enter a valid numeric value.";
      } else {
        delete updatedErrors[errorKey];
      }

      return updatedErrors;
    });
  };

  const handleInputChange3 = (e, yearType, complaintKey, field) => {
    const { value } = e.target;

    setComplaintsFiled((prev) => ({
      ...prev,
      [yearType]: {
        ...prev[yearType],
        [complaintKey]: {
          ...prev[yearType][complaintKey],
          [field]: value, // Allow any value (negative, text, etc.)
        },
      },
    }));

    // Clear errors for the specific field if valid
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (
        (field === "fliedYear" && value > 0) ||
        (field === "pending" && value >= 0) ||
        (field === "remark" && value.trim())
      ) {
        delete newErrors[`${yearType}.${complaintKey}.${field}`];
      }
      return newErrors;
    });
  };

  const validateComplaints = (setErrors) => {
    const errors = {};

    Object.keys(complaintsFiled).forEach((yearType) => {
      const yearComplaints = complaintsFiled[yearType];
      Object.keys(yearComplaints).forEach((complaintKey) => {
        const complaintData = yearComplaints[complaintKey];

        // Validate fliedYear - require a value (can be 0)
        if (
          complaintData.fliedYear === "" ||
          complaintData.fliedYear === null ||
          complaintData.fliedYear === undefined
        ) {
          errors[`${yearType}.${complaintKey}.fliedYear`] =
            "Filed during the year is required.";
        } else if (isNaN(complaintData.fliedYear)) {
          errors[`${yearType}.${complaintKey}.fliedYear`] =
            "Please enter a valid numeric value.";
        } else if (Number(complaintData.fliedYear) < 0) {
          errors[`${yearType}.${complaintKey}.fliedYear`] =
            "Value cannot be negative.";
        }

        // Validate pending - require a value (can be 0)
        if (
          complaintData.pending === "" ||
          complaintData.pending === null ||
          complaintData.pending === undefined
        ) {
          errors[`${yearType}.${complaintKey}.pending`] =
            "Pending resolution is required.";
        } else if (isNaN(complaintData.pending)) {
          errors[`${yearType}.${complaintKey}.pending`] =
            "Please enter a valid numeric value.";
        } else if (Number(complaintData.pending) < 0) {
          errors[`${yearType}.${complaintKey}.pending`] =
            "Pending resolution cannot be negative.";
        }

        // Validate remark
        if (!complaintData.remark || complaintData.remark.trim() === "") {
          errors[`${yearType}.${complaintKey}.remark`] =
            "Remarks are required.";
        }
      });
    });
    setErrors((prevErrors) => ({ ...prevErrors, ...errors }));
    return Object.keys(errors).length === 0;
  };

  const handleInputChange1 = (e, categoryKey, year, fieldPath, gender) => {
    const inputValue = e.target.value;
    if (!/^\d*\.?\d*$/.test(inputValue)) {
      return; // ❌ reject if not a valid number format
    }
    const numValue = parseFloat(inputValue);
    const updatedData = JSON.parse(JSON.stringify(minimumWages));
    const [mainField, subField] = fieldPath.split(".");
    const categoryData = updatedData[year][categoryKey];

    // Clear error for this specific field
    const errorKey = `${year}_${categoryKey}_${gender}_${mainField}`;
    if (minimumWagesErrors[errorKey]) {
      setMinimumWagesErrors((prev) => {
        const updated = { ...prev };
        delete updated[errorKey];
        return updated;
      });
    }

    const toNumOrNull = (v) =>
      v === "" || v == null || isNaN(parseFloat(v)) ? null : parseFloat(v);
    const zeroIfNull = (v) => (v == null ? 0 : v);

    // --- 1) Apply the user's change (do NOT return early; we want to recalc at the end) ---
    if (mainField === "total") {
      // total can be "" or a number
      categoryData[gender].total =
        inputValue === "" ? "" : isNaN(numValue) ? "" : numValue;
    } else {
      // wage fields (e.g., equalWageMin.number, equalWageMax.number)
      if (!categoryData[gender][mainField]) {
        categoryData[gender][mainField] = { number: "", percentage: "" };
      }

      if (subField === "number") {
        categoryData[gender][mainField].number =
          inputValue === "" ? "" : inputValue;
        // percentage is always recalculated below
      } else if (subField === "percentage") {
        // percentage is derived; ignore direct edits (optional: clear)
        categoryData[gender][mainField].percentage = "";
      }
    }

    // --- 2) Enforce: sum(wage numbers) <= total for the edited gender ---
    const wageKeys = Object.keys(categoryData[gender]).filter(
      (k) => k !== "total" && typeof categoryData[gender][k] === "object",
    );
    const totalForGender = toNumOrNull(categoryData[gender].total);

    const sumForGender = wageKeys.reduce(
      (acc, k) =>
        acc + zeroIfNull(toNumOrNull(categoryData[gender][k]?.number)),
      0,
    );

    // If user clears the total, also clear all dependent wage numbers and percentages for that gender
    if (
      mainField === "total" &&
      (inputValue === "" || totalForGender == null)
    ) {
      wageKeys.forEach((k) => {
        if (
          categoryData[gender][k] &&
          typeof categoryData[gender][k] === "object"
        ) {
          categoryData[gender][k].number = "";
          categoryData[gender][k].percentage = "";
        }
      });
    }

    // If total is set and sum exceeds it, clear the just-edited field (and its %)
    if (
      totalForGender != null &&
      sumForGender > totalForGender &&
      mainField !== "total"
    ) {
      categoryData[gender][mainField].number = "";
      categoryData[gender][mainField].percentage = "";
    }

    // If user changed total and now sum > total, clear ALL wage fields for that gender
    if (mainField === "total" && totalForGender != null) {
      const newSum = wageKeys.reduce(
        (acc, k) =>
          acc + zeroIfNull(toNumOrNull(categoryData[gender][k]?.number)),
        0,
      );
      if (newSum > totalForGender) {
        wageKeys.forEach((k) => {
          categoryData[gender][k].number = "";
          categoryData[gender][k].percentage = "";
        });
      }
    }

    // --- 3) Recalculate percentages for male/female individually ---
    const maleData = categoryData.male;
    const femaleData = categoryData.female;
    const totalData = categoryData.totalAddition;

    const maleTotal = toNumOrNull(maleData.total);
    const femaleTotal = toNumOrNull(femaleData.total);

    const allWageKeys = Array.from(
      new Set([
        ...Object.keys(maleData).filter(
          (k) => k !== "total" && typeof maleData[k] === "object",
        ),
        ...Object.keys(femaleData).filter(
          (k) => k !== "total" && typeof femaleData[k] === "object",
        ),
      ]),
    );

    allWageKeys.forEach((wageType) => {
      // Ensure structures exist
      if (!totalData[wageType])
        totalData[wageType] = { number: "", percentage: "" };
      if (!maleData[wageType])
        maleData[wageType] = { number: "", percentage: "" };
      if (!femaleData[wageType])
        femaleData[wageType] = { number: "", percentage: "" };

      const maleNumRaw = maleData[wageType].number;
      const femaleNumRaw = femaleData[wageType].number;

      const maleNum = toNumOrNull(maleNumRaw);
      const femaleNum = toNumOrNull(femaleNumRaw);

      // numbers total
      if (maleNum == null && femaleNum == null) {
        totalData[wageType].number = "";
      } else {
        totalData[wageType].number =
          zeroIfNull(maleNum) + zeroIfNull(femaleNum);
      }

      // individual percentages (only if that side has a number and total)
      maleData[wageType].percentage =
        maleNum != null && maleTotal != null && maleTotal > 0
          ? ((maleNum / maleTotal) * 100).toFixed(2)
          : "";

      femaleData[wageType].percentage =
        femaleNum != null && femaleTotal != null && femaleTotal > 0
          ? ((femaleNum / femaleTotal) * 100).toFixed(2)
          : "";

      // total percentage: average of available (non-empty) percentages
      const percVals = [
        maleData[wageType].percentage,
        femaleData[wageType].percentage,
      ]
        .map((p) => (p === "" ? null : parseFloat(p)))
        .filter((p) => p != null);

      totalData[wageType].percentage =
        percVals.length > 0
          ? (percVals.reduce((a, b) => a + b, 0) / percVals.length).toFixed(2)
          : "";
    });

    // --- 4) Recalculate grand total (number) for Total row ---
    const maleTotalNum = zeroIfNull(maleTotal);
    const femaleTotalNum = zeroIfNull(femaleTotal);
    const bothTotalsEmpty = maleTotal == null && femaleTotal == null;

    totalData.total = bothTotalsEmpty ? "" : maleTotalNum + femaleTotalNum;

    // --- 5) Commit once ---
    setMinimumWages(updatedData);
  };

  const handleInputChange = (type, rowIndex, year, colIndex, value) => {
    const updatedData = JSON.parse(JSON.stringify(data)); // Deep clone to avoid mutation
    const errors =
      type === "employees" ? { ...employeeErrors } : { ...workerErrors };

    // Basic validations
    if (!value && value !== 0) {
      errors[`${rowIndex}-${year}-${colIndex}`] = "This field is required";
    } else if (isNaN(value) || value < 0) {
      errors[`${rowIndex}-${year}-${colIndex}`] =
        "Only positive numbers are allowed";
    }
    // ✅ New validation: Column 1 must be <= Column 0
    else if (
      colIndex === 1 &&
      Number(value) > (updatedData[type][rowIndex][year][0] || 0)
    ) {
      updatedData[type][rowIndex][year][1] = "";
      errors[`${rowIndex}-${year}-${colIndex}`] =
        "Covered cannot be greater than Total Employees";
      return updatedData;
    } else if (
      colIndex === 0 &&
      Number(value) < (updatedData[type][rowIndex][year][1] || 0)
    ) {
      updatedData[type][rowIndex][year][1] = "";
    } else {
      delete errors[`${rowIndex}-${year}-${colIndex}`];
    }

    // Update the value
    updatedData[type][rowIndex][year][colIndex] =
      value === "" || value === null || value === undefined
        ? null
        : Number(value);

    // If Total column is cleared, also clear Covered and % for that row
    if (
      colIndex === 0 &&
      (value === "" || value === null || value === undefined)
    ) {
      updatedData[type][rowIndex][year][0] = null;
      updatedData[type][rowIndex][year][1] = null;
      updatedData[type][rowIndex][year][2] = null;
      delete errors[`${rowIndex}-${year}-1`];
      delete errors[`${rowIndex}-${year}-2`];
    }

    // Percentage calculation for first two rows
    if (rowIndex < 2) {
      const total = updatedData[type][rowIndex][year][0];
      const covered = updatedData[type][rowIndex][year][1];

      if (total != null && covered != null && total > 0) {
        const percentage = (covered / total) * 100;
        updatedData[type][rowIndex][year][2] = parseFloat(
          percentage.toFixed(3),
        );
      } else {
        updatedData[type][rowIndex][year][2] = null;
      }
    }

    // Update total row
    const totalRow = updatedData[type][2][year];
    totalRow[0] = [0, 1].reduce(
      (sum, rowIdx) => sum + (updatedData[type][rowIdx][year][0] || 0),
      0,
    );
    totalRow[1] = [0, 1].reduce(
      (sum, rowIdx) => sum + (updatedData[type][rowIdx][year][1] || 0),
      0,
    );
    totalRow[2] =
      totalRow[0] > 0
        ? parseFloat(((totalRow[1] / totalRow[0]) * 100).toFixed(3))
        : 0;

    setData(updatedData);

    if (type === "employees") {
      setEmployeeErrors(errors);
    } else {
      setWorkerErrors(errors);
    }
  };

  const fieldNameMapping = {
    rows: ["Permanent Employees", "Other than Permanent", "Total Employees"],
    columns: ["Total Employees", "Covered Employees", "Percentage"],
    years: { currentYear: "Current Year", previousYear: "Previous Year" },
  };

  // Validation function
  const validateAllFields = () => {
    const newEmployeeErrors = {};
    const newWorkerErrors = {};

    const validateRow = (type, dataSet, errors) => {
      dataSet.forEach((row, rowIndex) => {
        // Skip validation for the 'Total Employees' row (index 2)
        if (rowIndex === 2) return;

        ["currentYear", "previousYear"].forEach((year) => {
          const totalEmployees = row[year][0]; // Column 0: Total Employees
          const coveredEmployees = row[year][1]; // Column 1: Covered Employees

          row[year].forEach((value, colIndex) => {
            // Skip validation for percentage column (index 2)
            if (colIndex === 2) return;

            const fieldName = `${fieldNameMapping.rows[rowIndex]} - ${fieldNameMapping.columns[colIndex]} (${fieldNameMapping.years[year]})`;

            if (!value) {
              errors[`${rowIndex}-${year}-${colIndex}`] =
                `${fieldName}: This field is required`;
            } else if (isNaN(value) || value < 0) {
              errors[`${rowIndex}-${year}-${colIndex}`] =
                `${fieldName}: Only positive numbers are allowed`;
            }
          });

          // Check if "Covered Employees" exceeds "Total Employees"
          if (
            totalEmployees != null &&
            coveredEmployees != null &&
            coveredEmployees > totalEmployees
          ) {
            const fieldNameCovered = `${fieldNameMapping.rows[rowIndex]} - ${fieldNameMapping.columns[1]} (${fieldNameMapping.years[year]})`;
            errors[`${rowIndex}-${year}-1`] =
              `${fieldNameCovered}: Covered Employees cannot be greater than Total Employees`;
          }
        });
      });
    };

    validateRow("employees", data.employees, newEmployeeErrors);
    validateRow("workers", data.workers, newWorkerErrors);

    setEmployeeErrors(newEmployeeErrors);
    setWorkerErrors(newWorkerErrors);

    return (
      Object.keys(newEmployeeErrors).length === 0 &&
      Object.keys(newWorkerErrors).length === 0
    );
  };

  // // Function to calculate column sums

  const handleInputChange2 = (parentField, field, value) => {
    setFormData((prevData) => {
      if (parentField) {
        return {
          ...prevData,
          [parentField]: {
            ...prevData[parentField],
            [field]: value.trim(), // Trim to avoid unnecessary spaces
          },
        };
      }
      return {
        ...prevData,
        [field]: value.trim(),
      };
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (parentField === "other") {
        if (field === "others" && value.trim()) {
          delete newErrors["other.others"];
        }
        if (field === "percentageValue") {
          const percentageValue = Number(value);
          if (
            !isNaN(percentageValue) &&
            percentageValue >= 0 &&
            percentageValue <= 100
          ) {
            delete newErrors["other.percentageValue"];
          }
        }
      } else {
        if (value.trim()) {
          delete newErrors[field];
        } else {
          newErrors[field] = "This field is required.";
        }
      }

      return newErrors;
    });
  };

  const handleInputChange6 = (section, field, value) => {
    // Allow only numbers and optionally decimals
    if (value && !/^\d{0,3}(\.\d{0,2})?$/.test(value)) return;

    const numericValue = parseFloat(value);
    if (!isNaN(numericValue) && numericValue > 100) {
      setErrors((prev) => ({
        ...prev,
        [section ? `${section}.${field}` : field]:
          "Value should not exceed 100%",
      }));
      return;
    } else {
      setErrors((prev) => ({
        ...prev,
        [section ? `${section}.${field}` : field]: "",
      }));
    }

    if (section) {
      setFormData((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          [field]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };

  const placeholders = [
    ["Enter No.", "Enter No.", "%"],
    ["Enter No.", "Enter No.", "%"],
    ["Total", "Total", "%"],
  ];

  const handleDynamicLabelChange = (label) => {
    setDynamicLabel(label);
  };

  const validateForm = () => {
    const newErrors = {};

    // Validate currentFinancialYear
    const currentFinancialYearValue = parseFloat(formData.currentFinancialYear);
    if (
      isNaN(currentFinancialYearValue) ||
      currentFinancialYearValue < 0 ||
      currentFinancialYearValue > 100
    ) {
      newErrors.currentFinancialYear =
        "Please enter a valid percentage between 0 and 100.";
    }

    // Validate previousFinancialYear (if needed)
    const previousFinancialYearValue = parseFloat(
      formData.previousFinancialYear,
    );
    if (
      isNaN(previousFinancialYearValue) ||
      previousFinancialYearValue < 0 ||
      previousFinancialYearValue > 100
    ) {
      newErrors.previousFinancialYear =
        "Please enter a valid percentage between 0 and 100.";
    }

    if (
      (formData.humanRightsFocalPoint.status === "true" ||
        formData.humanRightsFocalPoint.status === true) &&
      (!formData.humanRightsFocalPoint.remark ||
        formData.humanRightsFocalPoint.remark.trim() === "")
    ) {
      newErrors.remark = "This field is required.";
    }
    if (
      formData.humanRightsRequirementsInAgreements.action === "true" &&
      (!formData.humanRightsRequirementsInAgreements.bref ||
        formData.humanRightsRequirementsInAgreements.bref.trim() === "")
    ) {
      newErrors.bref = "This field is required.";
    }
    // Check for empty or null values
    if (
      !formData.mechanismsToPreventAdverseConsequences ||
      formData.mechanismsToPreventAdverseConsequences.trim() === ""
    ) {
      newErrors.mechanismsToPreventAdverseConsequences =
        "This field is required.";
    }
    if (
      !formData.correctiveActionsForAssessments ||
      formData.correctiveActionsForAssessments.trim() === ""
    ) {
      newErrors.correctiveActionsForAssessments = "This field is required.";
    }

    Object.keys(formData).forEach((key) => {
      const value = formData[key];

      // Validate for percentage fields (Sexual Harassment, Discrimination, etc.)
      if (
        [
          "sexualHarassment",
          "discrimination",
          "childLabor",
          "forcedLabor",
          "wages",
        ].includes(key)
      ) {
        const percentageValue = Number(value); // Convert to number

        // Check if the value is empty or invalid
        if (value === "" || value === null || value === undefined) {
          newErrors[key] = "This field is required.";
        } else if (
          isNaN(percentageValue) ||
          percentageValue < 0 ||
          percentageValue > 100
        ) {
          newErrors[key] = "Please enter a valid percentage between 0 and 100.";
        }
      }

      if (
        ["totalComplaints", "complaintsFemaleEmployee", "poshUpheld"].includes(
          key,
        )
      ) {
        // Handle both string and number values properly
        const currentYearValue = value?.currentFinancialYear;
        const previousYearValue = value?.previousFinancialYear;

        // Convert to string if it's a number, then trim, or use empty string if undefined/null
        const currentYearStr =
          currentYearValue != null ? String(currentYearValue).trim() : "";
        const previousYearStr =
          previousYearValue != null ? String(previousYearValue).trim() : "";
        // Validation for Question 7 (POSH complaints) has been disabled
        // because the corresponding UI section is commented out.
        // if (
        //   ["totalComplaints", "complaintsFemaleEmployee", "poshUpheld"].includes(
        //     key
        //   )
        // ) {
        //   // Handle both string and number values properly
        //   const currentYearValue = value?.currentFinancialYear;
        //   const previousYearValue = value?.previousFinancialYear;
        //
        //   // Convert to string if it's a number, then trim, or use empty string if undefined/null
        //   const currentYearStr = currentYearValue != null ? String(currentYearValue).trim() : "";
        //   const previousYearStr = previousYearValue != null ? String(previousYearValue).trim() : "";

        // Required Field Validation
        if (!currentYearStr) {
          newErrors[`${key}.currentFinancialYear`] = "This field is required.";
        } else if (isNaN(currentYearStr) || parseFloat(currentYearStr) < 0) {
          // Numeric Validation
          newErrors[`${key}.currentFinancialYear`] =
            "Please enter a valid numeric value.";
        }

        if (!previousYearStr) {
          newErrors[`${key}.previousFinancialYear`] = "This field is required.";
        } else if (isNaN(previousYearStr) || parseFloat(previousYearStr) < 0) {
          // Numeric Validation
          newErrors[`${key}.previousFinancialYear`] =
            "Please enter a valid numeric value.";
        }
      }

      // General validations for other fields
      if (typeof value === "string" && !value.trim()) {
        newErrors[key] = `${key} is required.`;
      }

      // Validate 'other' fields
      if (key === "other") {
        if (value?.others?.trim() || value?.percentageValue) {
          if (!value?.others?.trim()) {
            newErrors["other.others"] =
              "This field is required when percentage is entered.";
          }
          if (value?.percentageValue == null || value?.percentageValue === "") {
            newErrors["other.percentageValue"] =
              "This field is required when 'Other-specify' is entered.";
          } else if (isNaN(value.percentageValue)) {
            newErrors["other.percentageValue"] = "Please enter a valid number.";
          } else if (value.percentageValue < 0 || value.percentageValue > 100) {
            newErrors["other.percentageValue"] =
              "Percentage must be between 0 and 100.";
          }
        }
      } else if (typeof value === "string" && !value.trim()) {
        newErrors[key] = "This field is required.";
      } else if (
        typeof value !== "string" &&
        value?.others?.trim &&
        !value.others.trim()
      ) {
        newErrors[key] = "This field is required.";
      }
    });
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      let v1 = validateForm();
      let v2 = validateAllFields();
      let v3 = validateComplaints(setErrors);
      const v4 = validateMedianRemuneration();
      const v5 = validateMinimumWages();
      if (!v1 || !v2 || !v3 || !v4 || !v5) {
        console.log(
          !v1,
          "p",
          !v2,
          !v3,
          !v4,
          !v5,
          "Validation failed - not submitting",
        );
        return;
      }

      const formatData = (row) => {
        if (!row) return { total: 0, noOfEmployee: 0, percentage: 0 };
        const total = row[0] || 0;
        const noOfEmployee = row[1] || 0;
        const percentage =
          row[2] || (total > 0 ? (noOfEmployee / total) * 100 : 0);

        return {
          total,
          noOfEmployee,
          percentage: parseFloat(percentage.toFixed(3)),
        };
      };

      const payload = {
        type: "SectionC",
        subType: "principle5",
        essentialIndicatorsSubmitted: true,
        essentialIndicators: {
          ...formData1,
          humanRightsTraining: {
            employee: {
              currentFinancialYear: {
                permanentEmployees: formatData(data.employees[0]?.currentYear),
                otherThanPermanent: formatData(data.employees[1]?.currentYear),
                total: formatData(data.employees[2]?.currentYear),
              },
              previousFinancialYear: {
                permanentEmployees: formatData(data.employees[0]?.previousYear),
                otherThanPermanent: formatData(data.employees[1]?.previousYear),
                total: formatData(data.employees[2]?.previousYear),
              },
            },
            workers: {
              currentFinancialYear: {
                permanentEmployees: formatData(data.workers[0]?.currentYear),
                otherThanPermanent: formatData(data.workers[1]?.currentYear),
                total: formatData(data.employees[2]?.currentYear),
              },
              previousFinancialYear: {
                permanentEmployees: formatData(data.workers[0]?.previousYear),
                otherThanPermanent: formatData(data.workers[1]?.previousYear),
                total: formatData(data.employees[2]?.previousYear),
              },
            },
          },

          minimumWages,
          remunerationDetails: {
            medianRemuneration,
            femalePercentage: {
              currentFinancialYear: formData.currentFinancialYear,
              previousFinancialYear: formData.previousFinancialYear,
            },
            // femalePercentage: formData.femalePercentage
          },
          humanRightsRequirementsInAgreements: {
            action: formData.humanRightsRequirementsInAgreements?.action,
            bref: formData.humanRightsRequirementsInAgreements?.bref,
          },
          humanRightsFocalPoint: formData.humanRightsFocalPoint,
          complaintsFiled: complaintsFiled,
          complaintsFiledUnderSexualHarassemnt: {
            totalComplaints: formData.totalComplaints,
            complaintsFemaleEmployee: formData.complaintsFemaleEmployee,
            poshUpheld: formData.poshUpheld,
          },
          mechanismsToPreventAdverseConsequences:
            formData.mechanismsToPreventAdverseConsequences,
          // humanRightsRequirementsInAgreements:
          //   formData.humanRightsRequirementsInAgreements,

          assessmentsForYear: {
            sexualHarassment: { plantsOffices: formData.sexualHarassment },
            discrimination: { plantsOffices: formData.discrimination },
            childLabor: { plantsOffices: formData.childLabor },
            forcedLabor: { plantsOffices: formData.forcedLabor },
            wages: { plantsOffices: formData.wages },
            other: formData.other,
          },
          correctiveActionsForAssessments:
            formData.correctiveActionsForAssessments,
        },
      };

      try {
        const response = await put(`${api}/brsr/update?id=${id}`, payload);
        setSnackOpen({
          open: true,
          message: "Data saved successfully!",
          severity: "success",
        });
        if (onSave) onSave(response.data);
      } catch (error) {
        setSnackOpen({
          open: true,
          message: "Failed to save data. Please try again.",
          severity: "error",
        });
      }
    } else onSave();
  };

  return (
    <Box>
      <p className={style.subHeading}> I. ESSENTIAL INDICATOR</p>
      <Typography
        sx={{
          fontWeight: 600,
          fontFamily: "Inter",
          fontSize: "16px",
          textIndent: "-1rem",
          paddingLeft: "0.9rem",
        }}
        gutterBottom
      >
        1. Employees and workers who have been provided training on human rights
        issues and policy(ies) of the entity, in the following format:
      </Typography>
      <Typography
        sx={{
          fontWeight: 600,
          fontFamily: "Inter",
          fontSize: "16px",
          paddingLeft: "0.9rem",
        }}
        gutterBottom
      >
        a. Employees
      </Typography>
      <ReusableTable
        disabled={disabled}
        data={data.employees}
        handleInputChange={(rowIndex, year, colIndex, value) =>
          handleInputChange("employees", rowIndex, year, colIndex, value)
        }
        placeholders={placeholders}
        errors={employeeErrors}
        type="employees"
      />
      {Object.values(employeeErrors).length > 0 && (
        <div style={{ marginLeft: "0.9rem", marginTop: "-1.5rem" }}>
          {Object.values(employeeErrors).map((error, index) => (
            <span
              key={index}
              style={{
                lineHeight: "1.2",
                marginTop: "-1rem",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
                marginRight: "0.5rem",
                listStyleType: "none",
              }}
            >
              {error}
            </span>
          ))}
        </div>
      )}
      <Typography
        sx={{
          fontWeight: 600,
          fontFamily: "Inter",
          fontSize: "16px",
          paddingLeft: "0.9rem",
        }}
        gutterBottom
      >
        b. Workers
      </Typography>
      <ReusableTable
        disabled={disabled}
        data={data.workers}
        handleInputChange={(rowIndex, year, colIndex, value) =>
          handleInputChange("workers", rowIndex, year, colIndex, value)
        }
        placeholders={placeholders}
        errors={workerErrors}
        type="workers"
      />
      {Object.values(workerErrors).length > 0 && (
        <div style={{ marginLeft: "0.9rem", marginTop: "-1.5rem" }}>
          {Object.values(workerErrors).map((error, index) => (
            <span
              key={index}
              style={{
                lineHeight: "1.2",
                marginTop: "-1rem",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
                marginRight: "0.5rem",
                listStyleType: "none",
              }}
            >
              {error}
            </span>
          ))}
        </div>
      )}
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "humanRightsTrainingDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Typography
        sx={{ fontWeight: 600, fontFamily: "Inter", fontSize: "16px", mt: 2 }}
        gutterBottom
      >
        2. Details of minimum wages paid to employees and workers:
      </Typography>
      <div>
        {categories.map((category) => (
          <div key={category.key}>
            <Typography
              sx={{
                fontWeight: 600,
                fontFamily: "Inter",
                fontSize: "16px",
                paddingLeft: "0.9rem",
              }}
              gutterBottom
            >
              {category.label}
            </Typography>
            <ReusableWageTable
              disabled={disabled}
              data={minimumWages}
              handleInputChange={handleInputChange1}
              category={category.key}
              errors={minimumWagesErrors}
            />
            {/* Show errors only for this specific category */}
            {Object.keys(minimumWagesErrors).filter((key) =>
              key.includes(category.key),
            ).length > 0 && (
              <div style={{ marginLeft: "0.9rem", marginTop: "0.5rem" }}>
                <span
                  style={{
                    lineHeight: "1.4",
                    color: "#d34040",
                    fontSize: "10px",
                    fontStyle: "italic",
                    display: "block",
                    wordWrap: "break-word",
                    maxWidth: "100%",
                  }}
                >
                  {Object.entries(minimumWagesErrors)
                    .filter(([key]) => key.includes(category.key))
                    .map(([key, error]) => error)
                    .join(", ")}
                </span>
              </div>
            )}
          </div>
        ))}
      </div>

      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "minimumWagesDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Grid item xs={12}>
        <Typography
          sx={{ fontWeight: 600, fontFamily: "Inter", fontSize: "16px", mt: 2 }}
          gutterBottom
        >
          3. Details of remuneration / salary / wages, in the following format:
        </Typography>

        <Typography
          sx={{
            fontWeight: 600,
            fontFamily: "Inter",
            fontSize: "16px",
            paddingLeft: "0.9rem",
          }}
          gutterBottom
        >
          a. Median remuneration / wages:
        </Typography>
        <TableField
          disabled={disabled}
          data={medianRemuneration}
          handleInputChange={handleInputChange5}
          error={validationErrors}
        />
        {/* {Object.values(validationErrors).length > 0 && (
          <div style={{ marginLeft: "0.9rem", marginTop: "0.5rem" }}>
            <span
              style={{
                lineHeight: "1.4",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
                display: "block",
                wordWrap: "break-word",
                maxWidth: "100%",
              }}
            >
              {Object.values(validationErrors).join(", ")}
            </span>
          </div>
        )} */}

        <Typography
          sx={{
            fontWeight: 600,
            fontFamily: "Inter",
            fontSize: "16px",
            mt: 5,
            paddingLeft: "0.9rem",
          }}
          gutterBottom
        >
          b. Gross wages paid to females as % of total wages paid by the entity,
          in the following format:
        </Typography>
        <TableContainer
          component={Paper}
          sx={{ borderRadius: "10px", width: "99%", marginLeft: "0.9rem" }}
        >
          <Table
            sx={{
              "& .MuiTableCell-root": {
                borderRight: "1px solid #e0e0e0",
                padding: "0px 16px",
              },
              tableLayout: "fixed",
              width: "100%",
            }}
          >
            <TableHead>
              <TableRow sx={{ bgcolor: "#1C486B", height: "40px" }}>
                <TableCell
                  sx={{
                    color: "white",
                    borderBottom: "1px solid white",
                    width: "40%",
                  }}
                ></TableCell>
                <TableCell
                  sx={{
                    color: "white",
                    borderBottom: "1px solid white",
                    width: "30%",
                  }}
                >
                  Current Financial Year
                </TableCell>
                <TableCell
                  sx={{
                    color: "white",
                    borderBottom: "1px solid white",
                    width: "30%",
                  }}
                >
                  Previous Financial Year
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <CustomTableRow
                disabled={disabled}
                label="Gross wages paid to females as % of total wages"
                fields={["currentFinancialYear", "previousFinancialYear"]}
                placeholder="Enter %"
                formData={formData}
                handleInputChange={handleInputChange6}
                showTotal
                errors={errors}
              />
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      {Object.entries(errors)
        .filter(([field]) =>
          ["currentFinancialYear", "previousFinancialYear"].includes(field),
        )
        .map(([field, error]) => (
          <span
            key={field}
            color="error"
            style={{
              lineHeight: "1.2",
              marginLeft: "0.9rem",
              marginTop: "0.5rem",
              color: "#d34040",
              fontSize: "10px",
              fontStyle: "italic",
            }}
          >
            {error}
          </span>
        ))}
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "remunerationDetailsDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Typography
        sx={{
          fontWeight: 600,
          fontFamily: "Inter",
          fontSize: "16px",
          mt: 3,
          textIndent: "-1rem",
          paddingLeft: "0.9rem",
        }}
        gutterBottom
      >
        4. Do you have a focal point (Individual/ Committee) responsible for
        addressing human rights impacts or issues caused or contributed to by
        the business?
      </Typography>
      <RadioGroup
        disabled={disabled}
        name="humanRightsFocalPoint"
        row
        value={formData.humanRightsFocalPoint.status}
        onChange={handleRadioChange}
        sx={{ marginLeft: "0.9rem" }}
      >
        <FormControlLabel
          value={true}
          control={<Radio disabled={disabled} />}
          label="Yes"
        />
        <FormControlLabel
          value={false}
          control={<Radio disabled={disabled} />}
          label="No"
        />
      </RadioGroup>
      {String(formData.humanRightsFocalPoint.status) === "true" && (
        <>
          {console.log(
            "Rendering TextField - errors.remark:",
            errors.remark,
            "!!errors.remark:",
            !!errors.remark,
          )}
          <TextField
            disabled={disabled}
            name="remark"
            value={formData.humanRightsFocalPoint.remark || ""}
            onChange={handleChange}
            fullWidth
            multiline
            rows={3}
            placeholder="Type Here"
            sx={{ width: "99%", marginLeft: "0.9rem" }}
            error={!!errors.remark}
            helperText={
              errors.remark ? (
                <Typography
                  variant="body2"
                  color="error"
                  style={{
                    lineHeight: "1.2",
                    margin: "2px 0",
                    color: "#d34040",
                    fontSize: "10px",
                    fontStyle: "italic",
                    marginLeft: "-10px",
                  }}
                >
                  {errors.remark}
                </Typography>
              ) : null
            }
          />
        </>
      )}
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "humanRightsFocalPointDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Typography
        sx={{
          fontWeight: 600,
          fontFamily: "Inter",
          fontSize: "16px",
          mt: 2,
          textIndent: "-1rem",
          paddingLeft: "0.9rem",
        }}
        gutterBottom
      >
        5. Number of Complaints on the following made by employees and workers:
      </Typography>
      <Typography
        sx={{
          fontWeight: 600,
          fontFamily: "Inter",
          fontSize: "16px",
          mt: 2,
          marginLeft: "0.9rem",
        }}
        gutterBottom
      >
        a.Current Financial Year
      </Typography>
      <ComplaintsTable
        disabled={disabled}
        title="a. Current Financial Year"
        yearType="currentFinancialYear1"
        complaintsFiled={complaintsFiled}
        onInputChange={handleInputChange3}
        errors={errors}
      />
      <Box sx={{ marginLeft: "0.9rem" }}>
        {Object.keys(errors)
          .filter((key) => key.startsWith("currentFinancialYear1"))
          .map((key) => (
            <span
              variant="body2"
              color="error"
              style={{
                lineHeight: "1.2",

                marginRight: "0.4rem",
                marginTop: "0.5rem",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {errors[key]}
            </span>
          ))}
      </Box>
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Typography
        sx={{
          fontWeight: 600,
          fontFamily: "Inter",
          fontSize: "16px",
          mt: 2,
          marginLeft: "0.9rem",
        }}
        gutterBottom
      >
        b.Previous Financial Year
      </Typography>
      <ComplaintsTable
        disabled={disabled}
        title="b. Previous Financial Year"
        yearType="previousFinancialYear1"
        complaintsFiled={complaintsFiled}
        onInputChange={handleInputChange3}
        errors={errors}
      />
      <Box sx={{ marginLeft: "0.9rem" }}>
        {Object.keys(errors)
          .filter((key) => key.startsWith("previousFinancialYear1"))
          .map((key) => (
            <span
              variant="body2"
              color="error"
              style={{
                lineHeight: "1.2",

                marginRight: "0.4rem",
                marginTop: "0.5rem",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {errors[key]}
            </span>
          ))}
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "complaintsFiledDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      {/* <Grid item xs={12}>
        <Typography
          sx={{
            fontWeight: 600,
            fontFamily: "Inter",
            fontSize: "16px",
            mt: 3,
            textIndent: "-1rem",
            paddingLeft: "0.9rem",
          }}
          gutterBottom
        >
          7. Complaints filed under the Sexual Harassment of Women at Workplace
          (Prevention, Prohibition and Redressal) Act, 2013, in the following
          format:
        </Typography>
        <TableContainer
          component={Paper}
          sx={{ borderRadius: "10px", width: "99%", marginLeft: "0.9rem" }}
        >
          <Table
            sx={{
              "& .MuiTableCell-root": {
                borderRight: "1px solid #e0e0e0",
                padding: "0px 16px",
              },
              tableLayout: "fixed",
              width: "100%",
            }}
          >
            <TableHead>
              <TableRow sx={{ bgcolor: "#1C486B", height: "40px" }}>
                <TableCell
                  sx={{
                    color: "white",
                    borderBottom: "1px solid white",
                    width: "40%",
                  }}
                ></TableCell>
                <TableCell
                  sx={{
                    color: "white",
                    borderBottom: "1px solid white",
                    width: "30%",
                  }}
                >
                  Current Financial Year
                </TableCell>
                <TableCell
                  sx={{
                    color: "white",
                    borderBottom: "1px solid white",
                    width: "30%",
                  }}
                >
                  Previous Financial Year
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <CustomTable
                disabled={disabled}
                label="Total Complaints reported under Sexual Harassment on of Women at Workplace (Prevention, Prohibition and Redressal) Act, 2013 (POSH)"
                fields={["currentFinancialYear", "previousFinancialYear"]}
                placeholder="No. of Complaints"
                // formData={formData}
                // handleInputChange={handleInputChange3}
                formData={formData.totalComplaints} // pass specific field data
                handleInputChange={(e) =>
                  handleInputChange4(e, "totalComplaints", null, e.target?.name)
                }
                showTotal
                errors={errors}
              />
              <CustomTable
                disabled={disabled}
                label="Complaints on POSH as a % of female employees / workers"
                fields={["currentFinancialYear", "previousFinancialYear"]}
                placeholder="No. of Complaints"
                formData={formData.complaintsFemaleEmployee} // pass specific field data
                handleInputChange={(e) =>
                  handleInputChange4(
                    e,
                    "complaintsFemaleEmployee",
                    null,
                    e.target?.name,
                  )
                }
                showTotal
                errors={errors}
              />
              <CustomTable
                disabled={disabled}
                label="Complaints on POSH upheld"
                fields={["currentFinancialYear", "previousFinancialYear"]}
                placeholder="No. of Complaints"
                formData={formData.poshUpheld} // pass specific field data
                handleInputChange={(e) =>
                  handleInputChange4(e, "poshUpheld", null, e.target?.name)
                }
                showTotal
                errors={errors}
              />
            </TableBody>
          </Table>
        </TableContainer>
        {Object.keys(errors).map((key) =>
          (key.startsWith("totalComplaints") ||
            key.startsWith("complaintsFemaleEmployee") ||
            key.startsWith("poshUpheld")) &&
          errors[key] ? (
            <span
              variant="body2"
              color="error"
              style={{
                lineHeight: "1.2",
                // margin: "2px 0",
                color: "#d34040",
                fontSize: "10px",
                margin: "0.9rem -0.4rem 0rem 0.9rem",
                fontStyle: "italic",
              }}
              key={key}
            >
              {errors[key]}
            </span>
          ) : null,
        )}
      </Grid>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "complaintsFiledUnderSexualHarassemntDoc",
          ml: 2,
          removeUpload,
        }}
      /> */}
      <Typography
        sx={{
          fontWeight: 600,
          fontFamily: "Inter",
          fontSize: "16px",
          mt: 2,
          textIndent: "-1rem",
          paddingLeft: "0.9rem",
        }}
        gutterBottom
      >
        6. Mechanisms to prevent adverse consequences to the complainant in
        discrimination and harassment cases.
      </Typography>
      <TextField
        disabled={disabled}
        fullWidth
        multiline
        rows={3}
        placeholder="Type Here"
        sx={{ width: "99%", marginLeft: "0.9rem" }}
        name="mechanismsToPreventAdverseConsequences"
        error={!!errors.mechanismsToPreventAdverseConsequences}
        value={formData.mechanismsToPreventAdverseConsequences || ""}
        onChange={handleChange}
        helperText={
          <Typography
            variant="body2"
            color="error"
            style={{
              lineHeight: "1.2",
              margin: "2px 0",
              color: "#d34040",
              fontSize: "10px",
              fontStyle: "italic",
              marginLeft: "-10px",
            }}
          >
            {errors.mechanismsToPreventAdverseConsequences}
          </Typography>
        }
      />
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "mechanismsToPreventAdverseConsequencesDoc",
          ml: 2,
          removeUpload,
        }}
      />
      <Typography
        sx={{
          fontWeight: 600,
          fontFamily: "Inter",
          fontSize: "16px",
          mt: 3,
          textIndent: "-1rem",
          paddingLeft: "0.9rem",
        }}
        gutterBottom
      >
        7. Do human rights requirements form part of your business agreements
        and contracts?
      </Typography>
      <RadioGroup
        disabled={disabled}
        name="humanRightsRequirementsInAgreements"
        row
        value={formData.humanRightsRequirementsInAgreements.action}
        onChange={handleRadioChange}
        sx={{ width: "99%", marginLeft: "0.9rem" }}
      >
        <FormControlLabel
          value={true}
          control={<Radio disabled={disabled} />}
          label="Yes"
        />
        <FormControlLabel
          value={false}
          control={<Radio disabled={disabled} />}
          label="No"
        />
      </RadioGroup>
      {String(formData.humanRightsRequirementsInAgreements.action) ===
        "true" && (
        <TextField
          name="bref"
          value={formData.humanRightsRequirementsInAgreements.bref || ""}
          onChange={handleChange}
          fullWidth
          multiline
          rows={3}
          placeholder="Type Here"
          sx={{ width: "99%", marginLeft: "0.9rem" }}
          error={!!errors.bref}
          helperText={
            <Typography
              variant="body2"
              color="error"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
                marginLeft: "-10px",
              }}
            >
              {errors.bref}
            </Typography>
          }
        />
      )}
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "humanRightsRequirementsInAgreementsDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Typography
        sx={{
          fontWeight: 600,
          fontFamily: "Inter",
          fontSize: "16px",
          mt: 2,
          textIndent: "-1rem",
          paddingLeft: "0.9rem",
        }}
        gutterBottom
      >
        8. Assessments for the year:
      </Typography>
      <TableContainer
        component={Paper}
        sx={{ mb: 2, width: "99%", marginLeft: "0.9rem" }}
      >
        <Table
          sx={{
            "& .MuiTableCell-root": {
              borderRight: "1px solidrgb(54, 21, 21)",
              padding: "0px 16px",
            },
            tableLayout: "fixed",
            width: "100%",
          }}
        >
          <TableHead>
            <TableRow sx={{ bgcolor: "#1C486B", height: "40px" }}>
              <TableCell
                sx={{
                  color: "white",
                  borderBottom: "1px solid white",
                  width: "12%",
                }}
              ></TableCell>
              <TableCell
                sx={{
                  color: "white",
                  borderBottom: "1px solid white",
                  width: "22%",
                }}
              >
                % of your plants and offices that were assessed (by entity or
                statutory authorities or third parties)
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <CustomTableRow
              disabled={disabled}
              label="Sexual Harassment"
              fields={["sexualHarassment"]}
              placeholder="Enter %"
              formData={formData}
              handleInputChange={handleInputChange2}
              errors={errors}
            />
            <CustomTableRow
              disabled={disabled}
              label="Discrimination at workplace"
              fields={["discrimination"]}
              placeholder="Enter %"
              formData={formData}
              handleInputChange={handleInputChange2}
              errors={errors}
            />
            <CustomTableRow
              disabled={disabled}
              label="Child Labor"
              fields={["childLabor"]}
              placeholder="Enter %"
              formData={formData}
              handleInputChange={handleInputChange2}
              errors={errors}
            />
            <CustomTableRow
              disabled={disabled}
              label="Forced Labor / Involuntary Labor"
              fields={["forcedLabor"]}
              placeholder="Enter %"
              formData={formData}
              handleInputChange={handleInputChange2}
              errors={errors}
            />
            <CustomTableRow
              disabled={disabled}
              label="Wages"
              fields={["wages"]}
              placeholder="Enter %"
              formData={formData}
              handleInputChange={handleInputChange2}
              errors={errors}
            />

            <CustomTableRow
              label="Other - Please Specify"
              isOtherRow={true}
              disabled={disabled}
              fields={[]}
              formData={formData}
              handleInputChange={handleInputChange2}
              placeholder="Enter %"
              errors={errors}
              dynamicLabel={dynamicLabel}
              handleDynamicLabelChange={handleDynamicLabelChange}
            />
          </TableBody>
        </Table>
      </TableContainer>
      {/* Displaying table-specific errors below the table */}
      <Box sx={{ margin: "-15px 0px 10px 10px" }}>
        {Object.entries(errors)
          .filter(([field]) =>
            [
              "sexualHarassment",
              "discrimination",
              "childLabor",
              "forcedLabor",
              "wages",
              "other.others",
              "other.percentageValue",
            ].includes(field),
          )
          .map(([field, error]) => (
            <span
              key={field}
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
                marginLeft: "0.4rem",
                listStyleType: "none",
              }}
            >
              {`${field.replace(/([A-Z])/g, " $1")}: ${error}`}
            </span>
          ))}
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "assessmentsForYearDoc",
          ml: 2,
          removeUpload,
        }}
      />
      <Typography
        sx={{
          fontWeight: 600,
          fontFamily: "Inter",
          fontSize: "16px",
          mt: 3,
          textIndent: "-1rem",
          paddingLeft: "0.9rem",
        }}
        gutterBottom
      >
        9. Provide details of any corrective actions taken or underway to
        address significant risks / concerns arising from the assessments at
        Question 10 above.
      </Typography>
      <TextField
        disabled={disabled}
        fullWidth
        multiline
        rows={3}
        placeholder="Type Here"
        sx={{ width: "99%", marginLeft: "0.9rem" }}
        name="correctiveActionsForAssessments"
        error={!!errors.correctiveActionsForAssessments}
        value={formData.correctiveActionsForAssessments || ""}
        onChange={handleChange}
        helperText={
          <Typography
            variant="body2"
            color="error"
            style={{
              lineHeight: "1.2",
              margin: "2px 0",
              color: "#d34040",
              fontSize: "10px",
              fontStyle: "italic",
              marginLeft: "-10px",
            }}
          >
            {errors.correctiveActionsForAssessments}
          </Typography>
        }
      />
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "correctiveActionsForAssessmentsDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {/* Submit Button */}
      {!hide && (
        <>
          {brsrReview ? (
            <Box sx={{ ml: "0.9rem", width: "99%" }}>
              <ReviewBox
                url={`/brsr/review/${id}`}
                handleSubmit={handleSubmit}
              />
            </Box>
          ) : (
            <Box textAlign="right" sx={{ mt: 3 }}>
              <Button
                variant="contained"
                sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
                onClick={handleSubmit}
              >
                Save & Continue <EastIcon sx={{ ml: 2 }} />
              </Button>
            </Box>
          )}
        </>
      )}
      {/* Snackbar for success/error messages */}
      <Snackbar
        open={snackOpen.open}
        message={snackOpen.message}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setSnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          severity={snackOpen.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default EssentialIndicator;
